import React from 'react';
import { NeoGrid, Views } from '@singularsystems/neo-react';
import { observer } from 'mobx-react';
import Note from '../../Models/Notes/Note';
import AddNotesModal from './AddNotesModal';
import { AppService, Types } from '../../DomainTypes';
import NoteVM from '../../Models/Notes/NoteVM';
import INoteListHost from '../../Models/Notes/INoteListHost';
import { DateUtils } from '@singularsystems/neo-core';

interface INotesProps {
    viewModel: NoteVM;
    parentModel: INoteListHost;
}

@observer
export default class AddNotesGrid extends React.Component<INotesProps> {

    public render() {
        let cache = AppService.get(Types.Domain.Services.DataCache)
        const viewModel = this.props.viewModel;
        const parentModel = this.props.parentModel;

        return (
            <div>
                <NeoGrid.Grid items={parentModel.notes} addButton={{ text: "Add a note", size: "sm", onClick: () => viewModel.createNewNote(parentModel) }}>
                    {(item: Note, meta) => (
                        <NeoGrid.Row>
                            <NeoGrid.Column display={item.meta.noteTypeId}
                                select={{ itemSource: cache.noteTypes, displayMember: "noteTypeName", renderAsText: true }} width="15%" />
                            <NeoGrid.Column display={item.meta.noteDescription} width="50%" />
                            <NeoGrid.Column display={item.meta.reminderDate} width="17.5%" />
                            <NeoGrid.Column display={item.completed.meta.on} label="Completed Date" width="17.5%" />
                            <NeoGrid.ButtonColumn
                                label="Complete"
                                editButton={(item.canComplete) ? {
                                    icon: "check", text: "Complete",
                                    onClick: () => viewModel.completeNote(item)
                                } : undefined} />
                        </NeoGrid.Row>
                    )}
                </NeoGrid.Grid>

                <AddNotesModal parentModel={parentModel} viewModel={viewModel} />
            </div>
        );
    }
}